module.exports = __webpack_public_path__ + "img/logo.29fc9574.png";